/* Serene Heat — PDP enhancements
 * Hover-to-zoom on desktop main image
 * Full-screen lightbox with prev/next/close
 * Size guide modal
 *
 * Thumbnail image swaps are owned by main-product.liquid.
 * Scroll reveal (data-serene-reveal) is owned by serene-animate.js.
 *
 * No external dependencies. Vanilla JS only.
 */
(function () {
  'use strict';

  var hasTouch = ('ontouchstart' in window) || (navigator.maxTouchPoints || 0) > 0;

  /* ------------------------------------------------------------------ */
  /* Hover zoom (desktop only)                                           */
  /* ------------------------------------------------------------------ */
  function initZoom(root) {
    if (hasTouch) return;
    var wrap = root.querySelector('[data-serene-main-wrap]');
    if (!wrap) return;

    function onMove(e) {
      var img = wrap.querySelector('[data-serene-main-img]');
      if (!img) return;
      var rect = wrap.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      x = Math.max(0, Math.min(100, x));
      y = Math.max(0, Math.min(100, y));
      img.style.transformOrigin = x + '% ' + y + '%';
    }

    wrap.addEventListener('mouseenter', function () {
      var img = wrap.querySelector('[data-serene-main-img]');
      if (!img) return;
      wrap.classList.add('is-zooming');
    });
    wrap.addEventListener('mousemove', onMove);
    wrap.addEventListener('mouseleave', function () {
      var img = wrap.querySelector('[data-serene-main-img]');
      wrap.classList.remove('is-zooming');
      if (img) {
        img.style.transformOrigin = '50% 50%';
      }
    });
  }

  /* ------------------------------------------------------------------ */
  /* Lightbox                                                            */
  /* ------------------------------------------------------------------ */
  function initLightbox(root) {
    var trigger = root.querySelector('[data-serene-main-wrap]');
    if (!trigger) return;

    var images = [];
    root.querySelectorAll('[data-serene-thumb]').forEach(function (t) {
      var src = t.getAttribute('data-full-src');
      var type = t.getAttribute('data-media-type') || 'image';
      if (src && type === 'image') images.push(src);
    });
    if (!images.length) {
      // Fallback to single main image
      var main = root.querySelector('[data-serene-main-img]');
      if (main && main.src) images.push(main.src);
    }
    if (!images.length) return;

    var current = 0;
    var overlay = null;

    function build() {
      overlay = document.createElement('div');
      overlay.className = 'serene-lightbox';
      overlay.setAttribute('role', 'dialog');
      overlay.setAttribute('aria-modal', 'true');
      overlay.setAttribute('aria-label', 'Image lightbox');
      overlay.innerHTML =
        '<button type="button" class="serene-lightbox__close" aria-label="Close">' +
          '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
        '</button>' +
        '<button type="button" class="serene-lightbox__nav serene-lightbox__nav--prev" aria-label="Previous image">' +
          '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>' +
        '</button>' +
        '<div class="serene-lightbox__stage">' +
          '<img class="serene-lightbox__img" alt="" src="">' +
        '</div>' +
        '<button type="button" class="serene-lightbox__nav serene-lightbox__nav--next" aria-label="Next image">' +
          '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>' +
        '</button>' +
        '<div class="serene-lightbox__count" data-count></div>';
      document.body.appendChild(overlay);

      overlay.querySelector('.serene-lightbox__close').addEventListener('click', close);
      overlay.querySelector('.serene-lightbox__nav--prev').addEventListener('click', function () { go(-1); });
      overlay.querySelector('.serene-lightbox__nav--next').addEventListener('click', function () { go(1); });
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) close();
      });
      document.addEventListener('keydown', onKey);
    }

    function render() {
      if (!overlay) return;
      var img = overlay.querySelector('.serene-lightbox__img');
      var count = overlay.querySelector('[data-count]');
      img.src = images[current];
      count.textContent = (current + 1) + ' / ' + images.length;
    }

    function go(delta) {
      current = (current + delta + images.length) % images.length;
      render();
    }

    function open(idx) {
      current = idx || 0;
      if (!overlay) build();
      render();
      requestAnimationFrame(function () {
        overlay.classList.add('is-open');
      });
      document.documentElement.classList.add('serene-lightbox-locked');
    }

    function close() {
      if (!overlay) return;
      overlay.classList.remove('is-open');
      document.documentElement.classList.remove('serene-lightbox-locked');
    }

    function onKey(e) {
      if (!overlay || !overlay.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') go(-1);
      else if (e.key === 'ArrowRight') go(1);
    }

    trigger.addEventListener('click', function () {
      // If clicked element is a video, skip lightbox
      if (trigger.querySelector('[data-serene-main-video]')) return;
      var main = root.querySelector('[data-serene-main-img]');
      if (!main) return;
      var idx = images.indexOf(main.src);
      open(idx >= 0 ? idx : 0);
    });
  }

  /* ------------------------------------------------------------------ */
  /* Size guide modal                                                    */
  /* ------------------------------------------------------------------ */
  function initSizeGuide(root) {
    var openers = root.querySelectorAll('[data-serene-size-guide-open]');
    var modal = root.querySelector('[data-serene-size-guide]');
    if (!openers.length || !modal) return;

    function open() {
      modal.hidden = false;
      requestAnimationFrame(function () {
        modal.classList.add('is-open');
      });
      document.documentElement.classList.add('serene-modal-locked');
    }
    function close() {
      modal.classList.remove('is-open');
      document.documentElement.classList.remove('serene-modal-locked');
      setTimeout(function () { modal.hidden = true; }, 220);
    }

    openers.forEach(function (o) {
      o.addEventListener('click', function (e) {
        e.preventDefault();
        open();
      });
    });
    modal.querySelectorAll('[data-serene-size-guide-close]').forEach(function (c) {
      c.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (!modal.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
    });
  }

  /* ------------------------------------------------------------------ */
  /* Boot                                                                */
  /* ------------------------------------------------------------------ */
  function init() {
    var root = document.querySelector('[data-serene-pdp]');
    if (!root) return;
    initZoom(root);
    initLightbox(root);
    initSizeGuide(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
